import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "drawer-content learning-form" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_8 = ["textContent"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Cancel", -1)
const _hoisted_10 = [
  _hoisted_9
]

import { PropType, computed, onMounted, reactive } from "vue";
import { useStore } from "vuex";
import useVuelidate from "@vuelidate/core";
import { Actions } from "@/store";
import { Learning, learningValidations } from "@/models/learning";
import Loading from "@/components/common/Loading.vue";
import Field from "@/components/common/Field.vue";
import FieldSwitch from "@/components/common/FieldSwitch.vue";
import FieldChoice, { Item } from "@/components/common/FieldChoice.vue";
import { useLoading } from "../common/loading.composable";

import { Application } from "@/models/application";
import { formatDate } from "date-fns";


export default /*#__PURE__*/_defineComponent({
  __name: 'LearningForm',
  props: {
  data: {
    type: Object as PropType<{ date: string }>,
    required: true
  }
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore();
const learning = reactive<Learning>({
  ...store.state.learning
});

const isNew = computed<boolean>(() => learning.id === -1);
const applicationOptions = computed<Item[]>(() => [
  { label: "None", value: undefined },
  ...store.state.applications.map((app: Application) => ({
    label: app.name,
    value: app.id
  }))
]);
const { loading, setLoading } = useLoading();

onMounted(() => {
  store.dispatch(Actions.GetApplications);

  store.dispatch(Actions.NewLearning);
  Object.assign(learning, {
    ...store.state.learning,
    date: formatDate(Date.parse(props.data.date), "yyyy-MM-dd")
  });
});
const $v = useVuelidate(learningValidations, { learning });
const emit = __emit;

const submit = async () => {
  $v.value.$touch();
  if (!$v.value.$invalid) {
    setLoading(true);
    await store.dispatch(Actions.StoreLearning, learning);

    setLoading(false);
    store.dispatch(Actions.NewLearning);
    Object.assign(learning, { ...store.state.learning });

    cancel();
  }
};

const cancel = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    learning
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _withModifiers(submit, ["prevent"]),
          class: _normalizeClass({ submitting: _unref(loading) })
        }, [
          _createElementVNode("h2", {
            textContent: _toDisplayString(isNew.value ? 'Add learning' : 'Edit learning')
          }, null, 8, _hoisted_2),
          (isNew.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Fill out the details of the learning"))
            : (_openBlock(), _createElementBlock("p", _hoisted_4, "Edit the details of the learning")),
          _createVNode(Field, {
            label: "Activity",
            validation: _unref($v).learning.name,
            modelValue: learning.activity,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((learning.activity) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(Field, {
            label: "Date",
            validation: _unref($v).learning.date,
            modelValue: learning.date,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((learning.date) = $event)),
            type: "date",
            styling: "field-date"
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(FieldChoice, {
            label: "Application",
            modelValue: learning.application_id,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((learning.application_id) = $event)),
            items: applicationOptions.value
          }, null, 8, ["modelValue", "items"]),
          _createVNode(FieldSwitch, {
            label: "Learned",
            modelValue: learning.learned,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((learning.learned) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "confirm",
              type: "button",
              disabled: _unref(loading),
              onClick: submit
            }, [
              _hoisted_7,
              _createElementVNode("span", {
                class: "text",
                textContent: _toDisplayString(isNew.value ? 'Add' : 'Edit')
              }, null, 8, _hoisted_8)
            ], 8, _hoisted_6),
            _createElementVNode("button", {
              class: "cancel",
              type: "button",
              onClick: cancel
            }, _hoisted_10),
            (_unref(loading))
              ? (_openBlock(), _createBlock(Loading, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ], 34))
      : _createCommentVNode("", true)
  ]))
}
}

})